import {
  Box,
  Button,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Subscription } from '../../resources/types/balanceTypes';
import { contractRefundAsync } from '../../redux/slices/contractsSlice';

interface Props {
  contractId: string;
  max: number;
  onSave: () => void;
  userSubscription?: Subscription | null;
}

export default function UserRefund({
  contractId,
  max,
  userSubscription,
  onSave,
}: Props) {
  const initialValues: Record<string, any> = {
    amountBalance: '',
    start: '',
    normal: '',
    pause: '',
    stop: '',
    reservation: '',
  };

  const handleRefund = async (data: Record<string, any>) => {
    console.log('--=-=- handleRefund', data);

    await contractRefundAsync(contractId, data);
    onSave()
  }

  const RefundSchema = Yup.object().shape({
    amountBalance: Yup.number()
      .typeError('Має бути числом')
      .min(0, 'Мінімум 0')
      .max(max, `Максимум ${max}`)
      .nullable(),

    ...(userSubscription ? ['start', 'normal', 'pause', 'stop', 'reservation'] : []).reduce((acc, key) => {
      // const maxValue = userSubscription?.[key as keyof Subscription] ?? undefined;
      const maxValue = 10;
      acc[key] = Yup.number()
        .typeError('Має бути числом')
        .min(0, 'Мінімум 0')
        .max(
          maxValue ?? Infinity,
          maxValue !== undefined
            ? `Максимум ${maxValue}`
            : 'Значення перевищує ліміт'
        )
        .nullable();
      return acc;
    }, {} as Record<string, Yup.NumberSchema<any>>),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={RefundSchema}
      onSubmit={(values, { setSubmitting }) => {
        const {
          amountBalance,
          start,
          normal,
          pause,
          stop,
          reservation,
        } = values;

        const payload: any = {
          contractId,
        };

        if (amountBalance !== '') {
          payload.amountBalance = Number(amountBalance);
        }

        const subs: Record<string, number> = {};
        const map = { start, normal, pause, stop, reservation };

        for (const [key, value] of Object.entries(map)) {
          if (value !== '') {
            const parsed = parseInt(value as string);
            if (!isNaN(parsed)) {
              subs[key] = parsed;
            }
          }
        }

        if (Object.keys(subs).length > 0) {
          payload.subscriptionAmounts = subs;
        }

        handleRefund(payload);
        setSubmitting(false);
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        isSubmitting
      }) => (
        <Form>
          <Stack spacing={2}>
            <Typography variant="subtitle1" fontWeight={600}>
              Параметри повернення
            </Typography>
            {
              max > 0 ? (
                <>
                  <TextField
                    name="amountBalance"
                    label="Сума для повернення (грн)"
                    type="number"
                    fullWidth
                    value={values.amountBalance}
                    onChange={handleChange}
                    error={Boolean(touched.amountBalance && errors.amountBalance)}
                    helperText={touched.amountBalance && errors.amountBalance}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Обробка...' : 'Повернути кошти'}
                  </Button>

                  <Typography variant="subtitle1" fontWeight={600}>
                    Або
                  </Typography>
                </>
              ) : null
            }


            {/* {userSubscription && (
              <>
                <Typography variant="subtitle2" fontWeight={500}>
                  Повернення секунд/дій абонементу:
                </Typography>

                <Stack direction="row" spacing={2}>
                  {(['start', 'normal', 'pause', 'stop', 'reservation'] as const).map((key) => (
                    <TextField
                      key={key}
                      name={key}
                      label={key.charAt(0).toUpperCase() + key.slice(1)}
                      type="number"
                      value={values[key]}
                      onChange={handleChange}
                      error={Boolean(touched[key as keyof typeof touched] && errors[key as keyof typeof errors])}
                      helperText={touched[key as keyof typeof touched] && errors[key as keyof typeof errors]}
                    />
                  ))}
                </Stack>
              </>
            )} */}

            <Button
              type="button"
              variant="contained"
              onClick={() => {
                handleRefund({
                  amountBalance: null,
                  subscriptionAmounts: null
                });
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Обробка...' : 'Повернути кошти повністю'}
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
}
